import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
	selector: 'app-time-select',
	templateUrl: './time-select.component.html',
	styleUrls: ['./time-select.component.scss'],
})
export class TimeSelectComponent implements OnInit {
	@Output() setTimeInHours = new EventEmitter();
	@Output() setTimeInMins = new EventEmitter();
	@Input() timeInHours = null;
	@Input() timeInMins = null;
	// timeInHours: string
	// timeInMins: string
	time = {
		timeInHours: '',
		timeInMins: '',
	};
	constructor() { }

	ngOnInit(): void {
		if (this.timeInHours) {
			this.time.timeInHours = this.timeInHours;
		}

		if (this.timeInMins) {
			this.time.timeInMins = this.timeInMins;
		}
	}

	updateTimeInHours() {
		this.setTimeInHours.emit(this.time.timeInHours);
	}

	updateTimeInMins() {
		this.setTimeInMins.emit(this.time.timeInMins);
	}

	increaseTime(type) {
		if (!Number(this.time[type])) {
			this.time[type] = '1';
			if (type === 'timeInHours') {
				this.setTimeInHours.emit(this.time.timeInHours);
			} else {
				this.setTimeInMins.emit(this.time.timeInMins);
			}
			return;
		}
		if (type === 'timeInHours') {
			this.setTimeInHours.emit(this.time.timeInHours);
		} else {
			this.setTimeInMins.emit(this.time.timeInMins);
		}
		Number(this.time[type]++);
	}

	decreaseTime(type) {
		if (Number(this.time[type]) < 1) {
			return;
		}
		if (type === 'timeInHours') {
			this.setTimeInHours.emit(this.time.timeInHours);
		} else {
			this.setTimeInMins.emit(this.time.timeInMins);
		}
		Number(this.time[type]--);
	}
}
